import {Grid} from '@material-ui/core';
import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {CheckboxInputGrid, MappingState} from 'Quoting/components/shared/CheckboxInputGrid';
import {FormWrapper} from 'Quoting/components/shared/QuoteFormWrapper';
import {SectionLabel} from 'Quoting/components/shared/SectionLabel';
import {A360ProductCd} from 'Quoting/models/Quoting';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {getPlanPropertiesPath} from '../../../PlansPropertyPaths';

interface ExclusionsAndLimitationsProps {
  exclusionPaths: MappingState[];
}

export const GPLUSpouseExclusionsAndLimitationsBlock = () => {
  const {selectedProduct, selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);
  const parentPath = `benefitPackagingDetail.plans[${selectedPlan?.planIndex ??
    0}].coverageDefs[${selectedCoverageIndex ?? 0}].exclusions`;

  const {getQuoteFieldValue, getBenefitLabelMapping} = useQuoteField();

  const planProperties = getPlanPropertiesPath(selectedPlan?.planIndex ?? 0, selectedCoverageIndex ?? 0);

  const benefitPaths = getBenefitLabelMapping(
    `${getQuoteFieldValue<string>(planProperties.planCd)}exclusions`,
    parentPath
  );

  return (
    <FormWrapper title="Exclusions And Limitations" collapsible withSeparator>
      <Grid container alignItems="center" style={{padding: '0 2rem'}}>
        {renderExclusionsAndLimitations(selectedProduct?.code, benefitPaths)}
      </Grid>
    </FormWrapper>
  );
};

const renderExclusionsAndLimitations = (selectedProductCd: A360ProductCd, benefitPaths: MappingState[]) => {
  if (selectedProductCd === A360ProductCd.GPLU) {
    return <GPLUExclusionsAndLimitations exclusionPaths={benefitPaths} />;
  }
  return <></>;
};

const GPLUExclusionsAndLimitations: React.FC<ExclusionsAndLimitationsProps> = ({exclusionPaths}) => {
  return (
    <>
      <SectionLabel variant="label-only" header="Exclusions" />
      <CheckboxInputGrid state={exclusionPaths} gridLength={3} />
    </>
  );
};
